import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/custom-made/src/components/configuratorClientContainer/configuratorClientContainer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/node_modules/.pnpm/@suits+ss-design-system@7.35.4/node_modules/@suits/ss-design-system/dist/ss-components/ss-components.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/custom-made/src/app/globals.scss");
